// Precision Nutrition Exercise Video Library
// Videos are on Vimeo at https://vimeo.com/precisionnutrition/<slug>
// Exercises without a specific video URL use the main library page as fallback.

const PN_BASE = "https://vimeo.com/precisionnutrition/";
const PN_LIBRARY = "https://www.precisionnutrition.com/video-exercise-library";

// Helper to build a Vimeo URL from a slug
function v(slug) {
  return PN_BASE + slug;
}

// Each entry: { name, category, videoUrl }
// videoUrl is null if no specific video is known (will show library link instead)
export const exerciseLibrary = [
  // ── Warmups & Mobility ──────────────────────────────────────────────────────
  { name: "90/90 Wall Balloon-Breathing", category: "Warmup & Mobility", videoUrl: null },
  { name: "Adductor Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Alternating Lateral Lunge Walk", category: "Warmup & Mobility", videoUrl: null },
  { name: "Banded No Money", category: "Warmup & Mobility", videoUrl: null },
  { name: "Bird Dog", category: "Warmup & Mobility", videoUrl: null },
  { name: "Bowler Squat", category: "Warmup & Mobility", videoUrl: null },
  { name: "Brady Band Series", category: "Warmup & Mobility", videoUrl: null },
  { name: "Brady Band Series - Without Band", category: "Warmup & Mobility", videoUrl: null },
  { name: "Cross-Body Lat Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Deep Neck Flexor Activation and Suboccipital Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "Deep Squat Wall Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "Dynamic Blackburn", category: "Warmup & Mobility", videoUrl: null },
  { name: "Fetal-Position Breathing", category: "Warmup & Mobility", videoUrl: null },
  { name: "Forearm Wall-Slide at 135 Degrees", category: "Warmup & Mobility", videoUrl: null },
  { name: "Hamstring Mobilization With Lacrosse Ball", category: "Warmup & Mobility", videoUrl: null },
  { name: "Hand Cross-Over", category: "Warmup & Mobility", videoUrl: null },
  { name: "Hip Flexor Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "Inchworm", category: "Warmup & Mobility", videoUrl: null },
  { name: "Lat and Triceps Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "No Money Drill", category: "Warmup & Mobility", videoUrl: null },
  { name: "Pec Minor Broomstick Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Pec Mobilization With Lacrosse Ball", category: "Warmup & Mobility", videoUrl: null },
  { name: "Pigeon Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "Piriformis Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Prone Hip External Rotation", category: "Warmup & Mobility", videoUrl: null },
  { name: "Prone Hip Internal Rotation", category: "Warmup & Mobility", videoUrl: null },
  { name: "Prone Hip-Flexed Rocking", category: "Warmup & Mobility", videoUrl: null },
  { name: "Quadruped Extension-Rotation", category: "Warmup & Mobility", videoUrl: null },
  { name: "Quadruped Rock Back", category: "Warmup & Mobility", videoUrl: null },
  { name: "Reach, Rock, Lift", category: "Warmup & Mobility", videoUrl: null },
  { name: "Reverse Lunge With Posterolateral Reach", category: "Warmup & Mobility", videoUrl: null },
  { name: "Reverse Pattern Single-Leg Romanian Deadlift", category: "Warmup & Mobility", videoUrl: null },
  { name: "Ribs-Down Breathing", category: "Warmup & Mobility", videoUrl: null },
  { name: "Rocked-Back Quadruped Extension-Rotation", category: "Warmup & Mobility", videoUrl: null },
  { name: "Rocking Ankle Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Romanian Deadlift With Dowel", category: "Warmup & Mobility", videoUrl: null },
  { name: "Scalene and Upper Trap Mobilization With Lacrosse Ball", category: "Warmup & Mobility", videoUrl: null },
  { name: "Scapular Pushup", category: "Warmup & Mobility", videoUrl: null },
  { name: "Scapular Pushup on Elbows", category: "Warmup & Mobility", videoUrl: null },
  { name: "Scapular Wall-Slide", category: "Warmup & Mobility", videoUrl: null },
  { name: "Side-Lying Clam Shell", category: "Warmup & Mobility", videoUrl: "https://vimeo.com/111523242" },
  { name: "Side-Lying Extension Rotation", category: "Warmup & Mobility", videoUrl: "https://vimeo.com/111523511" },
  { name: "Side-Lying Windmill", category: "Warmup & Mobility", videoUrl: null },
  { name: "Squat to Stand", category: "Warmup & Mobility", videoUrl: null },
  { name: "Squat to Stand With Overhead Reach", category: "Warmup & Mobility", videoUrl: null },
  { name: "Staggered-Stance Deep Squat Breathing", category: "Warmup & Mobility", videoUrl: null },
  { name: "Standing Thoracic Extension Rotation", category: "Warmup & Mobility", videoUrl: null },
  { name: "Super Couch Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "Super Couch Stretch Without Bench", category: "Warmup & Mobility", videoUrl: null },
  { name: "Supine Glute Bridge", category: "Warmup & Mobility", videoUrl: null },
  { name: "Supine Knee to Knee Pull-In", category: "Warmup & Mobility", videoUrl: "https://vimeo.com/123732072" },
  { name: "Thoracic Mobilization on Foam Roller", category: "Warmup & Mobility", videoUrl: null },
  { name: "Thoracic Mobilization With Bench", category: "Warmup & Mobility", videoUrl: null },
  { name: "Toy Soldier", category: "Warmup & Mobility", videoUrl: null },
  { name: "Wall Ankle Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Wall Glute Iso March", category: "Warmup & Mobility", videoUrl: null },
  { name: "Wall Hip Flexor Mobilization", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Knee to Chest", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Pull-Back Butt Kick", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Spiderman", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Spiderman With Hip Lift", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Spiderman With Overhead Reach", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Spiderman With Overhead Reach and Hip Lift", category: "Warmup & Mobility", videoUrl: null },
  { name: "Walking Warrior Lunge", category: "Warmup & Mobility", videoUrl: null },
  { name: "Warrior Lunge With Overhead Reach", category: "Warmup & Mobility", videoUrl: null },
  { name: "X-Band Box Walk", category: "Warmup & Mobility", videoUrl: null },
  { name: "X-Band Walk", category: "Warmup & Mobility", videoUrl: null },
  { name: "Yoga Downward Dog Stretch", category: "Warmup & Mobility", videoUrl: null },
  { name: "Yoga Plex", category: "Warmup & Mobility", videoUrl: null },
  { name: "Yoga Pushup", category: "Warmup & Mobility", videoUrl: null },

  // ── Core Work ────────────────────────────────────────────────────────────────
  { name: "Ab Wheel Iso", category: "Core", videoUrl: null },
  { name: "Ab Wheel Rollout", category: "Core", videoUrl: null },
  { name: "Band-Resisted Ab Wheel Iso", category: "Core", videoUrl: null },
  { name: "Bear Crawl", category: "Core", videoUrl: null },
  { name: "Dead Bug", category: "Core", videoUrl: null },
  { name: "Dead Bug With Legs Only", category: "Core", videoUrl: null },
  { name: "Dragon Flag", category: "Core", videoUrl: null },
  { name: "Elbow Plank Bodysaw", category: "Core", videoUrl: null },
  { name: "Feet-Elevated Side Plank", category: "Core", videoUrl: null },
  { name: "Half Get-Up", category: "Core", videoUrl: null },
  { name: "Half-Kneeling Band Chop", category: "Core", videoUrl: null },
  { name: "Half-Kneeling Band Lift", category: "Core", videoUrl: null },
  { name: "Half-Kneeling Cable Chop", category: "Core", videoUrl: null },
  { name: "Half-Kneeling Cable Lift", category: "Core", videoUrl: null },
  { name: "Half-Kneeling Pallof Press Iso", category: "Core", videoUrl: null },
  { name: "Half-Kneeling Pallof Press Iso With Band", category: "Core", videoUrl: null },
  { name: "Hanging Anti-Lateral Flexion", category: "Core", videoUrl: null },
  { name: "Hanging Unilateral March", category: "Core", videoUrl: null },
  { name: "Hinge to Side Plank", category: "Core", videoUrl: null },
  { name: "Landmine Rainbow", category: "Core", videoUrl: null },
  { name: "Lateral Lunge With Overhead Driver", category: "Core", videoUrl: null },
  { name: "Long-Lever Plank", category: "Core", videoUrl: null },
  { name: "Overhead Band Pallof Press", category: "Core", videoUrl: null },
  { name: "Pallof Press", category: "Core", videoUrl: null },
  { name: "Pallof Press Iso", category: "Core", videoUrl: null },
  { name: "Pallof Press Iso With Band", category: "Core", videoUrl: null },
  { name: "Pallof Press to Overhead", category: "Core", videoUrl: null },
  { name: "Pallof Press With Band", category: "Core", videoUrl: null },
  { name: "Plank", category: "Core", videoUrl: null },
  { name: "Plank Arm March", category: "Core", videoUrl: null },
  { name: "Reverse Crunch", category: "Core", videoUrl: null },
  { name: "Ring Plank", category: "Core", videoUrl: null },
  { name: "Salute Plank", category: "Core", videoUrl: null },
  { name: "Side Plank", category: "Core", videoUrl: null },
  { name: "Side Plank Wall-Slide", category: "Core", videoUrl: null },
  { name: "Side Plank Wall-Slide With Arm Abducted", category: "Core", videoUrl: null },
  { name: "Side Plank With Row", category: "Core", videoUrl: null },
  { name: "Single-Arm Plank", category: "Core", videoUrl: null },
  { name: "Single-Leg Plank", category: "Core", videoUrl: null },
  { name: "Single-Leg Slideboard Bodysaw", category: "Core", videoUrl: null },
  { name: "Slideboard Bodysaw", category: "Core", videoUrl: null },
  { name: "Stability Ball Rollout", category: "Core", videoUrl: null },
  { name: "Stir-The-Pot", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Band Chop", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Band Lift", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Cable Chop", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Cable Lift", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Overhead Pallof Press", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Pallof Press", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Pallof Press Iso", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Pallof Press Iso With Band", category: "Core", videoUrl: null },
  { name: "Tall-Kneeling Pallof Press With Band", category: "Core", videoUrl: null },
  { name: "Turkish Get-up", category: "Core", videoUrl: null },
  { name: "Wall-Press Abs", category: "Core", videoUrl: null },
  { name: "Bodyweight Get-Up", category: "Core", videoUrl: null },
  // Carries
  { name: "Single-Arm Walking Dumbbell Farmer's Carry", category: "Core", videoUrl: null },
  { name: "Walking Dumbbell Cross-Carry", category: "Core", videoUrl: null },
  { name: "Walking Farmer's Carry", category: "Core", videoUrl: null },
  { name: "Walking Fat Grip Farmer's Carry", category: "Core", videoUrl: null },
  { name: "Walking Goblet Carry", category: "Core", videoUrl: null },
  { name: "Walking Goblet Heartbeat Carry", category: "Core", videoUrl: null },
  { name: "Walking Single-Arm Bottom-Up Kettlebell Racked Carry", category: "Core", videoUrl: null },
  { name: "Walking Two-Arm Waiter's Carry", category: "Core", videoUrl: null },
  { name: "Walking Waiter's Carry", category: "Core", videoUrl: null },

  // ── Horizontal Pressing ──────────────────────────────────────────────────────
  { name: "Alternating Dumbbell Bench Press", category: "Horizontal Press", videoUrl: null },
  { name: "Band-Assisted Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Band-Resisted Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Band-Resisted Ring Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Barbell Bench Press", category: "Horizontal Press", videoUrl: null },
  { name: "Barbell Bench Press From Pins", category: "Horizontal Press", videoUrl: null },
  { name: "Barbell Floor Press", category: "Horizontal Press", videoUrl: null },
  { name: "Close-Grip Barbell Bench Press", category: "Horizontal Press", videoUrl: null },
  { name: "Close-Grip Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Dumbbell Bench Press", category: "Horizontal Press", videoUrl: null },
  { name: "Dumbbell Floor Press", category: "Horizontal Press", videoUrl: null },
  { name: "Dumbbell Flye EQI", category: "Horizontal Press", videoUrl: null },
  { name: "Explosive Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Feet-Elevated Band-Resisted Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Feet-Elevated Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Feet-Elevated Pushup to Single-Arm Support", category: "Horizontal Press", videoUrl: null },
  { name: "Hands-Elevated Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Hands-Elevated Pushup to Single-Arm Support", category: "Horizontal Press", videoUrl: null },
  { name: "Partial-Range Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Pushup Iso", category: "Horizontal Press", videoUrl: null },
  { name: "Pushup to Single-Arm Support", category: "Horizontal Press", videoUrl: null },
  { name: "Renegade Row With Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Renegade Row With Pushup and Feet Elevated", category: "Horizontal Press", videoUrl: null },
  { name: "Ring Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Dumbbell Bench Press", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Dumbbell Floor Press", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Half-Kneeling Band Press", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Half-Kneeling Cable Press", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Hands-Elevated Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Standing Split-Stance Band Press", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Arm Standing Split-Stance Cable Press", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Leg Band-Resisted Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Leg Feet-Elevated Band-Resisted Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Leg Feet-Elevated Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Leg Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Single-Leg Pushup Iso", category: "Horizontal Press", videoUrl: null },
  { name: "Spiderman Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "T-Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Weighted Pushup", category: "Horizontal Press", videoUrl: null },
  { name: "Weighted Ring Pushup", category: "Horizontal Press", videoUrl: null },

  // ── Vertical Pressing ────────────────────────────────────────────────────────
  { name: "Barbell Overhead Shrug", category: "Vertical Press", videoUrl: null },
  { name: "Barbell Push Press", category: "Vertical Press", videoUrl: null },
  { name: "Dumbbell Overhead Shrug", category: "Vertical Press", videoUrl: null },
  { name: "Dumbbell Push Press", category: "Vertical Press", videoUrl: null },
  { name: "Overhead Band Press", category: "Vertical Press", videoUrl: null },
  { name: "Seated Dumbbell Overhead Press", category: "Vertical Press", videoUrl: null },
  { name: "Single-Arm Dumbbell Push Press", category: "Vertical Press", videoUrl: null },
  { name: "Single-Arm Landmine Press", category: "Vertical Press", videoUrl: null },
  { name: "Single-Arm Overhead Band Press", category: "Vertical Press", videoUrl: null },
  { name: "Single-Arm Overhead Dumbbell Press", category: "Vertical Press", videoUrl: null },
  { name: "Single-Arm Seated Overhead Dumbbell Press", category: "Vertical Press", videoUrl: null },
  { name: "Single-Arm Tall-Kneeling Overhead Dumbbell Press", category: "Vertical Press", videoUrl: null },
  { name: "Split-Stance Dumbbell Push Press", category: "Vertical Press", videoUrl: null },
  { name: "Standing Barbell Overhead Press", category: "Vertical Press", videoUrl: null },
  { name: "Standing Split-Stance Landmine Press", category: "Vertical Press", videoUrl: null },
  { name: "Tall-Kneeling Landmine Press", category: "Vertical Press", videoUrl: null },

  // ── Horizontal Pulling ───────────────────────────────────────────────────────
  { name: "Band-Assisted Inverted Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Bent-Over Dumbbell Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Chest-Supported Dumbbell Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Chest-Supported Dumbbell Row Iso", category: "Horizontal Pull", videoUrl: null },
  { name: "Inverted Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Inverted Row With Feet Elevated", category: "Horizontal Pull", videoUrl: null },
  { name: "Inverted Row With Weight Vest", category: "Horizontal Pull", videoUrl: null },
  { name: "Neutral-Grip Seated Band Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Neutral-Grip Seated Cable Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Pronated-Grip Seated Band Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Pronated-Grip Seated Cable Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Renegade Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Ring Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Ring Row With Feet Elevated", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Band Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Dumbbell Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Half-Kneeling Band Row", category: "Horizontal Pull", videoUrl: "https://vimeo.com/111532987" },
  { name: "Single-Arm Half-Kneeling Cable Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Landmine Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Standing Band Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Standing Cable Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Standing Split-Stance Band Row", category: "Horizontal Pull", videoUrl: null },
  { name: "Single-Arm Standing Split-Stance Cable Row", category: "Horizontal Pull", videoUrl: null },
  { name: "T-Bar Row", category: "Horizontal Pull", videoUrl: null },

  // ── Vertical Pulling ─────────────────────────────────────────────────────────
  { name: "Band-Assisted Chin-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Band-Assisted Neutral-Grip Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Band-Assisted Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Band-Resisted Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Banded Pull-Down", category: "Vertical Pull", videoUrl: null },
  { name: "Cable Pull-Down", category: "Vertical Pull", videoUrl: null },
  { name: "Chin-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Eccentric Chin-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Eccentric Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Neutral-Grip Cable Pull-Down", category: "Vertical Pull", videoUrl: null },
  { name: "Neutral-Grip Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Pull-Up With Iso", category: "Vertical Pull", videoUrl: null },
  { name: "Single-Arm Half-Kneeling Band Pull-Down", category: "Vertical Pull", videoUrl: null },
  { name: "Weighted Chin-Up", category: "Vertical Pull", videoUrl: null },
  { name: "Weighted Neutral-Grip Pull-Up", category: "Vertical Pull", videoUrl: null },
  { name: "X-Lat Band Pull-Down", category: "Vertical Pull", videoUrl: null },

  // ── Squat ────────────────────────────────────────────────────────────────────
  { name: "Anderson Front Squat", category: "Squat", videoUrl: null },
  { name: "Assisted Bodyweight Squat to Box", category: "Squat", videoUrl: null },
  { name: "Assisted Lateral Squat", category: "Squat", videoUrl: null },
  { name: "Band-Resisted Goblet Squat", category: "Squat", videoUrl: null },
  { name: "Band-Resisted Squat", category: "Squat", videoUrl: null },
  { name: "Barbell Back Squat", category: "Squat", videoUrl: null },
  { name: "Barbell Box Squat", category: "Squat", videoUrl: null },
  { name: "Barbell Front Squat", category: "Squat", videoUrl: null },
  { name: "Barbell Front Squat Iso", category: "Squat", videoUrl: null },
  { name: "Barbell Front Squat to Box", category: "Squat", videoUrl: null },
  { name: "Bodyweight Lateral Squat", category: "Squat", videoUrl: null },
  { name: "Bodyweight Squat to Box", category: "Squat", videoUrl: null },
  { name: "Dumbbell 1 1/4 Full Squat", category: "Squat", videoUrl: null },
  { name: "Dumbbell Full Squat", category: "Squat", videoUrl: null },
  { name: "Goblet 1 1/4 Squat", category: "Squat", videoUrl: null },
  { name: "Goblet Lateral Squat", category: "Squat", videoUrl: null },
  { name: "Goblet Squat", category: "Squat", videoUrl: null },
  { name: "Goblet Squat Iso", category: "Squat", videoUrl: null },
  { name: "Goblet Squat to Box", category: "Squat", videoUrl: null },
  { name: "Goblet Squat With Pulse", category: "Squat", videoUrl: null },
  { name: "Hip-Belt Squat", category: "Squat", videoUrl: null },
  { name: "Overhead Barbell Squat", category: "Squat", videoUrl: null },
  { name: "Overhead Broomstick Squat", category: "Squat", videoUrl: null },
  { name: "Plate Squat", category: "Squat", videoUrl: null },
  { name: "Prisoner Squat", category: "Squat", videoUrl: null },

  // ── Hip Hinge ────────────────────────────────────────────────────────────────
  { name: "Band-Resisted Glute Bridge", category: "Hip Hinge", videoUrl: null },
  { name: "Banded Hip Extension", category: "Hip Hinge", videoUrl: null },
  { name: "Barbell Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Barbell Glute Bridge", category: "Hip Hinge", videoUrl: null },
  { name: "Barbell Hip Thrust", category: "Hip Hinge", videoUrl: null },
  { name: "Barbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Barbell Sumo Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Dumbbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Dumbbell Sumo Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Rack Pull", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Arm Dumbbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Barbell Glute Bridge", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Barbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Dumbbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Glute Bridge", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Hip Thrust", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Offset Dumbbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Single-Arm Dumbbell Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Supine Hips-Elevated Leg Curl", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Band-Resisted Romanian Deadlift", category: "Hip Hinge", videoUrl: null },
  { name: "Slideboard Leg Curl", category: "Hip Hinge", videoUrl: null },
  { name: "Single-Leg Slideboard Leg Curl", category: "Hip Hinge", videoUrl: null },
  { name: "Supine Hips-Extended Leg Curl", category: "Hip Hinge", videoUrl: null },
  { name: "Trap Bar Deadlift", category: "Hip Hinge", videoUrl: null },

  // ── Single-Leg ───────────────────────────────────────────────────────────────
  { name: "Alternating Goblet Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Assisted Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Barbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Barbell Reverse Lunge With a Front Squat Grip", category: "Single-Leg", videoUrl: null },
  { name: "Barbell Slideboard Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Barbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Bodyweight Cross-Over Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Bodyweight Lateral Lunge With Assistance", category: "Single-Leg", videoUrl: null },
  { name: "Bodyweight Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Bodyweight Split Squat With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Bodyweight Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Cross-Over Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Reverse Lunge From Deficit", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Reverse Lunge to Romanian Deadlift", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Slideboard Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Dumbbell Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Lateral Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Lateral Lunge Walk", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Split Squat With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Goblet Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Kettlebell Split Squat With Blocked Knee - Single Kettlebell Racked, Offset", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Cross-Over Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Reverse Lunge From Deficit", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Reverse Lunge to Romanian Deadlift", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Slideboard Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Offset Dumbbell Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Overhead Dumbbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Overhead Dumbbell Reverse Lunge From Deficit", category: "Single-Leg", videoUrl: null },
  { name: "Overhead Offset Dumbbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Overhead Offset Dumbbell Reverse Lunge From Deficit", category: "Single-Leg", videoUrl: null },
  { name: "Rear-Foot-Elevated Barbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Rear-Foot-Elevated Bodyweight Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Rear-Foot-Elevated Dumbbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Rear-Foot-Elevated Dumbbell Split Squat Jump", category: "Single-Leg", videoUrl: "https://vimeo.com/122681426" },
  { name: "Rear-Foot-Elevated Goblet Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Rear-Foot-Elevated Offset Dumbbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Rear-Foot-Elevated Single-Arm Dumbbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Reverse Landmine Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Reverse Lunge From Deficit", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Reverse Lunge to Romanian Deadlift", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Reverse Lunge With Blocked Knee", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Slideboard Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Split Squat", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Dumbbell Step-Up", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Overhead Dumbbell Reverse Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Single-Arm Overhead Dumbbell Reverse Lunge From Deficit", category: "Single-Leg", videoUrl: null },
  { name: "Single-Leg Eccentric Squat to Box", category: "Single-Leg", videoUrl: null },
  { name: "Single-Leg Squat to Box", category: "Single-Leg", videoUrl: null },
  { name: "Walking Dumbbell Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Walking Goblet Lunge", category: "Single-Leg", videoUrl: null },
  { name: "Walking Offset Dumbbell Lunge", category: "Single-Leg", videoUrl: null },

  // ── Jumps ────────────────────────────────────────────────────────────────────
  { name: "Alternating Barbell Split Jump", category: "Jumps", videoUrl: null },
  { name: "Alternating Bodyweight Split Jump", category: "Jumps", videoUrl: null },
  { name: "Alternating Dumbbell Split Jump", category: "Jumps", videoUrl: null },

  // ── Arms ─────────────────────────────────────────────────────────────────────
  { name: "Alternating Dumbbell Curl", category: "Arms", videoUrl: null },
  { name: "Band Press-Down", category: "Arms", videoUrl: null },
  { name: "Banded Curl", category: "Arms", videoUrl: null },
  { name: "Barbell Curl", category: "Arms", videoUrl: null },
  { name: "Dumbbell Curl", category: "Arms", videoUrl: null },
  { name: "Dumbbell Hammer Curl", category: "Arms", videoUrl: null },
  { name: "Lying Dumbbell Rolling Triceps Extension", category: "Arms", videoUrl: null },
  { name: "Lying Dumbbell Triceps Extension", category: "Arms", videoUrl: "https://vimeo.com/111255275" },
  { name: "Overhead Band Triceps Extension", category: "Arms", videoUrl: v("overhead-band-tricep-extension") },
  { name: "Overhead Cable Triceps Extension", category: "Arms", videoUrl: v("overhead-cable-tricep-extension") },
  { name: "Seated Dumbbell Curl", category: "Arms", videoUrl: null },
  { name: "Single-Arm Dumbbell Curl", category: "Arms", videoUrl: null },
  { name: "Single-Arm Lying Dumbbell Rolling Triceps Extension", category: "Arms", videoUrl: null },
  { name: "Single-Arm Lying Dumbbell Triceps Extension", category: "Arms", videoUrl: null },
  { name: "Single-Arm Plate Curl", category: "Arms", videoUrl: null },
  { name: "Triceps Press-Down", category: "Arms", videoUrl: null },

  // ── Corrective Work ──────────────────────────────────────────────────────────
  { name: "Band Pull-Apart", category: "Corrective", videoUrl: null },
  { name: "Band Stomp", category: "Corrective", videoUrl: null },
  { name: "Band-Resisted Scapular Pushup", category: "Corrective", videoUrl: null },
  { name: "Banded External Rotation at 30 Degrees Abduction", category: "Corrective", videoUrl: null },
  { name: "Banded External Rotation at 90 Degrees Abduction", category: "Corrective", videoUrl: null },
  { name: "Banded Face Pull", category: "Corrective", videoUrl: null },
  { name: "Banded Scapular Protraction", category: "Corrective", videoUrl: null },
  { name: "Brady Band Series", category: "Corrective", videoUrl: null },
  { name: "Cable External Rotation at 30 Degrees Abduction", category: "Corrective", videoUrl: null },
  { name: "Cable External Rotation at 90 Degrees Abduction", category: "Corrective", videoUrl: null },
  { name: "Cable External Rotation on Knee", category: "Corrective", videoUrl: null },
  { name: "Dumbbell External Rotation on Knee", category: "Corrective", videoUrl: null },
  { name: "Face Pull", category: "Corrective", videoUrl: null },
  { name: "Half-Kneeling Band Overhead Shrug", category: "Corrective", videoUrl: null },
  { name: "Prone Row to External Rotation", category: "Corrective", videoUrl: null },
  { name: "Prone T Raise", category: "Corrective", videoUrl: null },
  { name: "Prone Y Raise", category: "Corrective", videoUrl: null },
  { name: "Prone YTI", category: "Corrective", videoUrl: null },
  { name: "Side-Lying Banded External Rotation With Abduction", category: "Corrective", videoUrl: null },
  { name: "Side-Lying Cable External Rotation With Abduction", category: "Corrective", videoUrl: null },
  { name: "Side-Lying Dumbbell External Rotation With Abduction", category: "Corrective", videoUrl: null },
  { name: "Single-Arm Band Pull-Apart", category: "Corrective", videoUrl: null },
  { name: "Single-Arm Face Pull", category: "Corrective", videoUrl: null },
  { name: "Supine Banded No Money Drill", category: "Corrective", videoUrl: "https://vimeo.com/123731794" },
  { name: "Supine Banded Scapular Protraction", category: "Corrective", videoUrl: null },
  { name: "Supine Psoas March", category: "Corrective", videoUrl: null },

  // ── Metabolic Work ───────────────────────────────────────────────────────────
  { name: "Bodyweight Squat Thrust", category: "Metabolic", videoUrl: null },
  { name: "Burpee", category: "Metabolic", videoUrl: null },
  { name: "Burpee Without Pushup", category: "Metabolic", videoUrl: null },
  { name: "Dumbbell Squat Thrust", category: "Metabolic", videoUrl: null },
  { name: "Mountain Climber", category: "Metabolic", videoUrl: null },
];

// Build a fast lookup map: name (lowercase) → entry
export const exerciseMap = new Map(
  exerciseLibrary.map((e) => [e.name.toLowerCase(), e])
);

// Get library entry for a given exercise name (case-insensitive)
export function getExerciseInfo(name) {
  return exerciseMap.get(name.toLowerCase()) || null;
}

// Get all exercise names as a sorted array
export const allExerciseNames = exerciseLibrary.map((e) => e.name).sort();

// Get the video URL for an exercise (returns library page if no specific video)
export function getVideoUrl(name) {
  const info = getExerciseInfo(name);
  if (!info) return PN_LIBRARY;
  return info.videoUrl || PN_LIBRARY;
}

// ─── Fuzzy exercise matching ───────────────────────────────────────────────────

const ABBREVS = { db: "dumbbell", bb: "barbell", kb: "kettlebell", rdl: "romanian deadlift", bw: "bodyweight", sa: "single arm", sl: "single leg" };

function normalizeEx(s) {
  return s.toLowerCase().replace(/[^a-z0-9\s]/g, " ").split(/\s+/).filter(Boolean).map(t => ABBREVS[t] ?? t).join(" ");
}

// Returns { name, score } — best library match for a raw exercise name (score 0–1).
export function fuzzyMatchExercise(rawName) {
  const rawTokens = new Set(normalizeEx(rawName).split(" "));
  let bestName = allExerciseNames[0];
  let bestScore = 0;
  for (const libName of allExerciseNames) {
    const libTokens = new Set(normalizeEx(libName).split(" "));
    const intersection = [...rawTokens].filter(t => libTokens.has(t)).length;
    const union = new Set([...rawTokens, ...libTokens]).size;
    const score = union > 0 ? intersection / union : 0;
    if (score > bestScore) { bestScore = score; bestName = libName; }
  }
  return { name: bestName, score: bestScore };
}
